import alt from 'framework/alt';
import ReduxStoreActions from 'actions/ReduxStoreActions';

/**
 * Stores a reference to the Redux store that is accessible
 * from Alt. This is necessary for situations where a value
 * is stored in both Alt and Redux, and to keep that value
 * in sync we need to dispatch a Redux action from an
 * Alt action creator
 *
 * Think twice before using this.
 */
class ReduxStoreStore {
  constructor() {
    this.state = {
      reduxStore: {},
    };

    this.bindListeners({
      setReduxStore: ReduxStoreActions.setReduxStore,
    });
  }

  setReduxStore(reduxStore) {
    this.setState({ reduxStore });
  }
}

export default alt.createStore(ReduxStoreStore, 'ReduxStoreStore');
